<template>
  <div>
    <textarea
      class="form-control"
      ref="kindeditor"
      v-model="outContent"
      name="content"
      v-loaded-callback="initKindeditor"
    ></textarea>
  </div>
</template>

<script>
import config from "../api/config";
import "kindeditor/kindeditor-all.js";
import "kindeditor/lang/zh-CN.js";
import "kindeditor/themes/default/default.css";
export default {
  name: "kindeditor",
  props: ["options", "value"],
  data() {
    return {
      editor: null,
      outContent: "" //输出的html
    };
  },
  watch: {
    outContent: "updateValue",
    value: "setDefault"
  },
  created() {
    this.outContent = this.value;
  },
  methods: {
    clear() {
      this.outContent = "";
      this.editor.html("");
    },
    initKindeditor() {
      var _this = this;
      // 默认参数
      var options = {
        width: "700px",
        height: "600px",
        resizeType: 1,
        allowPreviewEmoticons: false,
        uploadJson: config.baseURL + "/api/upload",
        basePath: "/static/",
        allowImageUpload: true,
        allowMediaUpload: true,
        allowFileManager: false,
        afterBlur: function() {
          this.sync();
        },
        afterChange() {
          _this.outContent = this.html();
        },
        htmlTags:{
        font : ['color', 'size', 'face', '.background-color','.margin', '.padding'],
        span : [
                '.color', '.background-color', '.font-size', '.font-family', '.background',
                '.font-weight', '.font-style', '.text-decoration', '.vertical-align', '.line-height','.margin', '.padding','.position','.float','.margin-top','.margin-right','.margin-bottom'
        ],
        div : [
                'align', '.border', '.margin', '.padding', '.text-align', '.color',
                '.background-color', '.font-size', '.font-family', '.font-weight', '.background',
                '.font-style', '.text-decoration', '.vertical-align', '.margin-left','.float','.position','.top','.left','.right','.bottom','.margin-top','.margin-right','.margin-bottom'
        ],
        video : [
                'align', '.border', '.margin', '.padding', '.text-align', '.color',
                '.background-color', '.font-size', '.font-family', '.font-weight', '.background',
                '.font-style', '.text-decoration', '.vertical-align', '.margin-left','src','controls','muted','poster','.width','.height','autoplay','loop','preload','controlsList'
        ],
        table: [
                'border', 'cellspacing', 'cellpadding', 'width', 'height', 'align', 'bordercolor',
                '.padding', '.margin', '.border', 'bgcolor', '.text-align', '.color', '.background-color',
                '.font-size', '.font-family', '.font-weight', '.font-style', '.text-decoration', '.background',
                '.width', '.height', '.border-collapse','.max-width','.max-height','postion','.top','.left','right','.bottom'
        ],
        'td,th': [
                'align', 'valign', 'width', 'height', 'colspan', 'rowspan', 'bgcolor',
                '.text-align', '.color', '.background-color', '.font-size', '.font-family', '.font-weight',
                '.font-style', '.text-decoration', '.vertical-align', '.background', '.border','.margin', '.padding','.max-width','.max-height','postion','.top','.left','right','.bottom'
        ],
        a : ['href', 'target', 'name'],
        embed : ['src', 'width', 'height', 'type', 'loop', 'autostart', 'quality', '.width', '.height', 'align', 'allowscriptaccess'],
        img : ['src', 'width', 'height', 'border', 'alt', 'title', 'align', '.width', '.height', '.border','.margin', '.padding','position','.position','.top','.left','.font-style'],
        'p,ol,ul,li,blockquote,h1,h2,h3,h4,h5,h6' : [
                'align', '.text-align', '.color', '.background-color', '.font-size', '.font-family', '.background',
                '.font-weight', '.font-style', '.text-decoration', '.vertical-align', '.text-indent', '.margin-left','.margin', '.padding','.class','class'
        ],
        pre : ['class'],
        hr : ['class', '.page-break-after'],
        'br,tbody,tr,strong,b,sub,sup,em,i,u,strike,s,del' : []
},
        items: [
          "source",
          "|",
          "undo",
          "redo",
          "|",
          "preview",
          "print",
          "template",
          "code",
          "cut",
          "copy",
          "paste",
          "plainpaste",
          "wordpaste",
          "|",
          "justifyleft",
          "justifycenter",
          "justifyright",
          "justifyfull",
          "insertorderedlist",
          "insertunorderedlist",
          "indent",
          "outdent",
          "subscript",
          "superscript",
          "clearhtml",
          "quickformat",
          "selectall",
          "|",
          "fullscreen",
          "/",
          "formatblock",
          "fontname",
          "fontsize",
          "|",
          "forecolor",
          "hilitecolor",
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "lineheight",
          "removeformat",
          "|",
          "image",
          "media",
          "insertfile",
          "table",
          "hr",
          "emoticons",
          "pagebreak",
          "anchor",
          "link",
          "unlink",
          "|",
          "about"
        ]
      };
      // 调用外部参数
      if (_this.options) {
        for (var i in _this.options) {
          options[i] = _this.options[i];
        }
      }
      _this.editor = KindEditor.create(_this.$refs.kindeditor, options);
    },
    // 设置初始值
    setDefault() {
      this.editor.html(this.value);
    },
    // 修改父件的值
    updateValue() {
      this.$emit("getcontent", this.outContent);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/kindeditor.vue